import type { Grant } from "./grant";
import type GroupId from "./GroupId";
import { MAX_CHARACTERS_SM } from "../constants";
import { requireText } from "../utils/validation/base";
import { object, pick } from "valibot";

export type Group = {
  id: GroupId;
  name: string;
  grants: Grant[];
  externallyManaged: boolean;
};

const groupSchema = object({
  name: requireText(MAX_CHARACTERS_SM, true),
});

export const createGroupSchema = pick(groupSchema, ["name"]);
export const editGroupSchema = pick(groupSchema, ["name"]);
